var map = {
	"./puzzle8.jpg": "4a19",
	"./puzzle8.mp3": "972c",
	"./puzzle8_1.jpg": "d1ed",
	"./puzzle8_2.jpg": "6930",
	"./puzzle8_2.mp3": "fd8d",
	"./puzzle8_3.jpg": "bac3",
	"./puzzle8_3.mp3": "69e0",
	"./puzzle8_4.jpg": "a2a5",
	"./puzzle8_4.mp3": "caaf",
	"./puzzle8_5.jpg": "e7a8",
	"./puzzle8_5.mp3": "9611",
	"./puzzle8_6.jpg": "ac4c",
	"./puzzle8_7.jpg": "ec22",
	"./puzzle8_7.mp3": "38d6",
	"./puzzle8_8.jpg": "061f",
	"./puzzle8_9.jpg": "6c2b",
	"./puzzle8_9.mp3": "bac1",
	"./puzzle8_b1.png": "2e40",
	"./puzzle8_b2.png": "1492",
	"./puzzle8_b3.png": "a353",
	"./puzzle8_b4.png": "1a04",
	"./puzzle8_b5.png": "4974",
	"./puzzle8_b6.png": "b0da",
	"./puzzle8_b7.png": "c03b",
	"./puzzle8_b8.png": "1bf1",
	"./puzzle8_b9.png": "0e5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6933";